import Algonomy from '@package/services/src/Algonomy/services/AlgonomyRecommendations';

import { apiClient } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { TOP_SELLING_PRODUCTS } from './types';

const algonomyRecommendations = new Algonomy(apiClient);

const useTopSellingsProducts = () => {
  const { data: topSellingProducts } = useStrictQuery(
    [TOP_SELLING_PRODUCTS],
    async () => {
      const res = await algonomyRecommendations.getTopSellings();

      return res?.data;
    },
    { refetchOnWindowFocus: false, refetchOnMount: false },
  );
  return { topSellingProducts };
};

export default useTopSellingsProducts;
